











































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import BarChart from '@/components/chart/BarChart.vue'
import { IBarChartData } from '@/interfaces'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { BillingModule } from '@/store/modules/billing.module'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Card,
    Icon,
    BarChart,
    LoaderWrapper
  }
})
export default class ClientsByModulesStatistics extends Vue {
  billingInstanceModule: BillingModule = getModule(BillingModule, this.$store);
  isLoading: boolean = false;
  params = {
    months: 5,
    skip: 0
  };
  data: Array<{ data: IBarChartData[], date: Date }>= [];

  get statistics () {
    return this.$store.state.billing.clientsByModulesStatistics || []
  }

  async mounted () {
    this.fetchStatistics()
  }

  titleFormatter (total: number) {
    return total
  }

  slideTo (skip: number) {
    this.params.skip += skip
    this.fetchStatistics()
  }

  isPrevAvailable () {
    return this.data.length === 5
  }

  isNextAvailable () {
    const today = new Date()
    if (this.data.length > 0) {
      const date = this.data[this.data.length - 1].date
      const month = date.getMonth()
      const year = date.getFullYear()
      return month + 12 * year < today.getMonth() + 12 * today.getFullYear()
    } else {
      return true
    }
  }

  async fetchStatistics () {
    this.isLoading = true
    await this.billingInstanceModule.fetchClientsByModuleStatistics(this.params)
    this.initStatistics()
    this.isLoading = false
  }
  initStatistics () {
    const maxTotal = Math.max(...this.statistics.map((item: any) => item.mpa + item.mp + item.p))
    console.log('maxTotal', maxTotal)
    this.data = this.statistics.map((item: any) => {
      const date = new Date(item.date)
      date.setHours(23)
      
      return {
        total: maxTotal,
        data: [{
          items: [{
            value: item.mpa,
            color: '#F0F0FA',
            label: 'Mailing, Payments, Aging'
          },
          {
            value: item.p,
            color: '#9966FF',
            label: 'Payments'
          }, {
            value: item.mp,
            color: '#66CCFF',
            label: 'Mailing, Payments'
          }]
        }],
        date
      }
    })
  }
}
